<template>
  <div>
    <el-form label-width="80px" inline @submit.native.prevent class="elementui-common-form-styles" v-highlight>
      <el-form-item>
        <el-input v-model="tagGroupForm.keyWord" clearable placeholder="请输入标签组或内容标签名称"></el-input>
      </el-form-item>

      <el-form-item class="bg-transparent">
        <el-button type="primary" @click="queryAction">查询</el-button>
        <el-button @click="onConfigModify()">新建标签组</el-button>
      </el-form-item>
    </el-form>

    <Viewport v-model="tableHeight">
      <el-table class="common-el-table-styles" v-loading="tableLoading" :data="tableData" :height="tableHeight" border style="width: 100%">
        <el-table-column prop="id" label="组ID" width="80"> </el-table-column>
        <el-table-column prop="groupName" label="标签组名称" width="110"> </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onConfigModify(row)">编辑</el-button>
            <el-button type="text" @click="ontableRowRemove(row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="prop" label="组内内容标签" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div>
              {{ row.labels.map((l) => l.content).join(',') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="opName" label="新建人" width="90"> </el-table-column>
        <el-table-column prop="createTime" label="新建时间" width="140"> </el-table-column>
        <el-table-column prop="upOpName" label="更新人" width="90"> </el-table-column>
        <el-table-column prop="upTime" label="更新时间" width="140"> </el-table-column>
      </el-table>

      <div class="pager" style="text-align: right">
        <el-pagination
          :current-page.sync="pageInfo.page.pageId"
          :page-size.sync="pageInfo.page.pageSize"
          :total="pageInfo.total"
          @current-change="queryTableData"
          layout="prev, pager, next"
          background
        >
        </el-pagination>
      </div>
    </Viewport>

    <!-- 新增，编辑标签组 -->
    <TagGroupConfigFormModal ref="configForm" v-model="showConfigForm" @confirm="queryTableData"></TagGroupConfigFormModal>
  </div>
</template>
<script>
import { clone } from '@/common/js/just.js'
import { datetimeToSec } from '@/common/js/filters.js'
import { getTagGroupList, removeTagGroupRow } from '@/api/manage.model.js'
import TagGroupConfigFormModal from './components/tag-group-config.vue'
export default {
  name: 'tagsgroup',
  components: {
    TagGroupConfigFormModal
  },
  data() {
    return {
      tableData: [],
      showConfigForm: false,
      tableHeight: 500,
      tagGroupForm: {
        keyWord: ''
      },
      pageInfo: {
        total: 0,
        page: {
          pageId: 1,
          pageSize: 20
        }
      }
    }
  },
  created() {
    this.queryTableData()
  },
  methods: {
    queryAction() {
      this.pageInfo.page.pageId = 1
      this.queryTableData()
    },
    queryTableData() {
      if (this.tableLoading) return
      this.tableLoading = true

      getTagGroupList({ ...this.pageInfo.page, ...this.tagGroupForm })
        .then((data) => {
          const { list, page_info } = data
          if (list?.length) {
            this.tableData = list.map((item) => {
              return {
                ...item,
                createTime: datetimeToSec(item.createTime),
                upTime: datetimeToSec(item.upTime)
              }
            })
          } else {
            this.tableData = []
          }
          this.pageInfo.total = page_info.total_number
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    /**
     * @description: 新增|编辑标签组
     * @param {*} row
     */
    onConfigModify(row) {
      if (row) {
        // 回显编辑内容
        this.$refs.configForm.fillForm(clone(row))
      }
      this.showConfigForm = true
    },
    ontableRowRemove(row) {
      this.$confirm(`确认删除${row.groupName}?`, '提示', {
        type: 'warning'
      }).then(() => {
        removeTagGroupRow({ groupId: row.id }).then((data) => {
          if (data) {
            this.$Message.success('删除成功')
            this.queryTableData()
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
